tr(:data-test='`exclusive-${index}`')
  td
    .fp-image.-rounded
      img(:src='exclusive.imageUrl' alt='Exclusive image')
  td(:title='exclusive.name')
    .fp-icon-with-text
      router-link.fp-link(:to='{ name: \'updateExclusive\', params: { clubSlug: club.slug, exclusiveSlug: exclusive.slug  } }')
        span.fp-text(data-test='slug') {{ exclusive.slug }}
      i.fp-icon.fp-glyph-eye-slash.-s18.-color-shade-400(v-if='!exclusive.visible' data-test='not-visible-icon')
  td
    span.fp-tag(data-test='category')
      i.fp-icon(:class='exclusive.categoryIcon')
      span.fp-tag--text {{ t(`exclusive.categories.${exclusive.category}`) }}
  td {{ exclusive.price.totalCost.text }}
  td {{ exclusive.auctionLot.bids.length }}
  td(data-test='likes')
    .fp-horizontal-spacing.-s-sm.-items-center.-justify-end
      .fp-text {{ exclusive.likes }}
      i.fp-icon.-s16.fp-glyph-heart.-color-danger
  td
    DropdownVue(:name='`actions-exclusive-${exclusive.slug}`')
      DropdownItemVue(:id='exclusive.slug' :text='t(\'exclusivesPage.actions.update\')' icon='edit' :routeLocation='{ name: \'updateExclusive\', params: { clubSlug: club.slug, exclusiveSlug: exclusive.slug  } }' :data-test='`edit-exclusive-${exclusive.slug}`')
      DropdownItemVue(:text='t(\'exclusivesPage.actions.clone\')' icon='copy' :routeLocation='{ name: \'createExclusive\', params: { clubSlug: club.slug }, query: { from: `${club.slug}/${exclusive.slug}`} }' :data-test='`clone-exclusive-${exclusive.slug}`')
      DropdownSeparatorVue
      DropdownItemVue(:text='t(\'exclusivesPage.actions.see\')' icon='arrow-square-in' :href='`${club.webappUrl}/exclusives/${exclusive.slug}`' :data-test='`go-to-exclusive-${exclusive.slug}`')
